import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from '../../store';

const initialState: { showOverlay: boolean } = {
  showOverlay: false,
};
export const showProgressOverlaySlice = createSlice({
  name: 'showProgressOverlay',
  initialState,
  reducers: {
    showOverlay: (state) => {
      state.showOverlay = true;
    },
    hideOverlay: (state) => {
      state.showOverlay = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(revertAll, () => initialState);
  },
});

export default showProgressOverlaySlice.reducer;
export const { showOverlay, hideOverlay } = showProgressOverlaySlice.actions;
